<template>
<v-container v-if="!isMobile">
  <nav>
<v-app-bar app>
      <v-toolbar-title><v-breadcrumbs
      :items="items"
      large
    ></v-breadcrumbs></v-toolbar-title>
    </v-app-bar>
  </nav>

<v-row>
  <v-col cols="2">
<div class="pa-1">
      <v-select
          :items="boardName"
          value="boardName1A"
          label="8 Channel DB"
          v-model="boardItem"
          @change="updateBoard"
          :item-text="
                        (boardName) => {
                          return (
                              boardName.boardName1A
                          );
                          }
                        "
          prepend-icon="mdi-integrated-circuit-chip"
          outlined
          dense
          hide-details
        ></v-select>
      </div>
  </v-col>

  <v-col cols="2">
      <div class="pa-1">
      <v-select
          :items="voltBoard"
          value="boardName"
          label="Single Phase DB"
          v-model="voltBoardItem"
          @change="updateBoard"
          :item-text="
                        (voltBoard) => {
                          return (
                              voltBoard.boardName
                          );
                          }
                        "
          outlined
          dense
          hide-details
        ></v-select>
      </div>
  </v-col>

  <v-col>
    <v-md-date-range-picker
                :presets="presets"
                opens="right"
                @change="updateData"
              >
                <v-card class="pa-2" slot="input"
                  ><v-icon color="red darken-2"> mdi-clock-outline </v-icon> <span style="font-size: 15px;">{{ formatDate(values1) }} - </span>
                  <span style="font-size: 15px;" v-if="values2 > Date.now()">Now</span><span style="font-size: 15px;" v-else> {{ formatDate(values2) }}</span>
                </v-card>
              </v-md-date-range-picker>
              <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
             <v-btn
      :loading="loading5"
      :disabled="loading5"
      :color="!timer ? 'red' : 'green'"
      :class="!timer ? 'ma-1 white--text' : 'ma-1 white--text' "
      @click="timer = !timer, loader = 'loading5'"
      fab
      small
      v-bind="attrs"
      v-on="on" 
    >
      <v-icon dark>
        {{ !timer ? 'mdi-play' : 'mdi-pause' }}
      </v-icon>
    </v-btn>
     </template>
      <span> {{ !timer ? 'Enable Auto Refresh Page' : 'Disable Auto Refresh Page' }}</span>
    </v-tooltip>
  </v-col>
</v-row>

<v-row v-if="totalAll.length != 0">
 <v-col v-if="loading">       
 <v-container style="height: 200px;">
      <v-row
        class="fill-height"
        align-content="center"
        justify="center"
      >
        <v-col
          class="text-subtitle-1 text-center"
          cols="12"
        >
          Getting your chart
        </v-col>
        <v-col cols="6">
          <v-progress-linear
            color="blue"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
        </v-col>
      </v-row>
    </v-container>
    </v-col>
   <v-col v-else>
   <apexchart width="800" height="400" type="line" :options="currentChart" :series="currentSeries"></apexchart>
  </v-col>

   <v-col>
<v-row dense>
     <v-col>
       <p class="mx-auto text-center" style="font-size:12px;color:black;">Current</p>
 <v-card
    class="mx-auto text-center"
    color="white"
    dark
    max-width="200"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:12px;color:black;">
        Recently
      </div>
      <div style="font-size:18px;color:black;">
       {{totalAll[0].toFixed(2)}}<span style="font-size:10px;color:black;">A</span>
      </div>
    </v-card-text>
  </v-card>
    </v-col>
</v-row>

<v-row dense>
   <v-col>
  <v-card
    class="mx-auto text-center"
    color="grey lighten-1"
    dark
    max-width="200"
    max-height="100"
  >
      <div style="font-size:12px;color:black;">
        Peak
      </div>
      <div style="font-size:14.5px;color:black;">
      {{Math.max(...totalAll).toFixed(2)}}<span style="font-size:10px;color:black;">A</span>
      </div>
  </v-card>
   <v-card
    class="mx-auto text-center"
    color="white"
    dark
    max-width="200"
    max-height="100"
  >
   <div style="font-size:12px;color:black;">
        Min
      </div>
      <div style="font-size:14.5px;color:black;">
        {{Math.min(...totalAll).toFixed(2)}}<span style="font-size:10px;color:black;">A</span>
      </div>
  </v-card>
    </v-col>
</v-row>

<div v-if="voltage.length != 0">
<v-row dense v-if="boardItem == 'DB1F'">
     <v-col>
 <v-card
    class="mx-auto text-center"
    color="red"
    dark
    max-width="200"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:12px;">
        Voltage(Recently)
      </div>
      <div style="font-size:18px;">
       {{volt1[0]}}<span style="font-size:10px;">V</span>
      </div>
    </v-card-text>
  </v-card>
    </v-col>
</v-row>
<v-row dense v-if="boardItem == 'DBPR'">
     <v-col>
 <v-card
    class="mx-auto text-center"
    color="yellow"
    dark
    max-width="200"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:12px;color:black;">
        Voltage(Recently)
      </div>
      <div style="font-size:18px;color:black;">
       {{volt2[0]}}<span style="font-size:10px;color:black;">V</span>
      </div>
    </v-card-text>
  </v-card>
    </v-col>
</v-row>
<v-row dense v-if="boardItem == 'DBGF'">
     <v-col>
 <v-card
    class="mx-auto text-center"
    color="blue"
    dark
    max-width="200"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:12px;">
        Voltage(Recently)
      </div>
      <div style="font-size:18px;">
       {{volt3[0]}}<span style="font-size:10px;">V</span>
      </div>
    </v-card-text>
  </v-card>
    </v-col>
</v-row>

<v-row>
     <v-col>
 <v-card
    class="mx-auto text-center"
    color="cyan"
    dark
    max-width="200"
    max-height="100"
  >

    <v-card-text>
      <div style="font-size:12px;">
        Power Consumption(Recently)
      </div>
      <div style="font-size:18px;">
       {{totalPower}}<span style="font-size:10px;">kWh</span>
      </div>
    </v-card-text>
  </v-card>
    </v-col>
</v-row>
</div>
    </v-col>
</v-row>


</v-container>

<v-container v-else>
  <v-row>
      <div class="pa-1">
   <v-select
          :items="boardName"
          value="boardName1A"
          label="Board Name"
          v-model="boardItem"
          @change="updateBoard"
          :item-text="
                        (boardName) => {
                          return (
                              boardName.boardName1A
                          );
                          }
                        "
          prepend-icon="mdi-integrated-circuit-chip"
          solo
          hide-details
          style="font-size: 12px;"
        ></v-select>
   </div>
   <v-container>
 <v-md-date-range-picker
                :presets="presets"
                opens="right"
                @change="updateData"
              >
                <v-card class="pa-3" tile slot="input"
                  > <v-icon color="red darken-2"> mdi-clock-outline </v-icon><span style="font-size: 12px;">{{ formatDate(values1) }} - </span>
                  <span style="font-size: 12px;" v-if="values2 > Date.now()">Now</span><span style="font-size: 12px;" v-else> {{ formatDate(values2) }}</span>
                </v-card>
              </v-md-date-range-picker>
              <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
             <v-btn
      :loading="loading5"
      :disabled="loading5"
      :color="!timer ? 'red' : 'green'"
      :class="!timer ? 'ma-1 white--text' : 'ma-1 white--text' "
      @click="timer = !timer, loader = 'loading5'"
      fab
      small
      v-bind="attrs"
      v-on="on" 
    >
      <v-icon dark>
        {{ !timer ? 'mdi-play' : 'mdi-pause' }}
      </v-icon>
    </v-btn>
     </template>
      <span> {{ !timer ? 'Enable Auto Refresh Page' : 'Disable Auto Refresh Page' }}</span>
    </v-tooltip>
   </v-container>
    </v-row>

     <v-container v-if="loading">
  <v-skeleton-loader
          v-bind="attrs"
          type="table-thead, table-tbody"
        ></v-skeleton-loader>
 </v-container>
 <v-container v-else>
<v-row>
  <v-col cols="12">
    
   
  </v-col>
</v-row>
 </v-container>
</v-container>
</template>


<script>
import Vue from "vue";
import axios from "axios";
import moment from 'moment';
import VueApexCharts from 'vue-apexcharts'

Vue.component("apexchart", VueApexCharts);

export default {
  data: () => ({
    items: [
        {
          text: 'Dashboard',
          disabled: false,
          href: '/',
        },
        {
          text: 'Energy',
          disabled: true,
          href: '',
        },
        {
          text: 'Usage By DB',
          disabled: true,
          href: '',
        },
      ],
      isMobile: true,
      values1: moment().subtract(24, "hour"),
      values2: moment().endOf("day"),
      presets: [
        {
          label: "Last 1 Hour",
          range: [moment().subtract(1, "hour"), moment().endOf("day")],
        },
        {
          label: "Last 3 Hour",
          range: [moment().subtract(3, "hour"), moment().endOf("day")],
        },
        {
          label: "Last 12 Hour",
          range: [moment().subtract(12, "hour"), moment().endOf("day")],
        },
        {
          label: "Today",
          range: [moment().startOf("day"), moment().endOf("day")],
        },
        {
          label: "This Week",
          range: [moment().subtract(6, "day"), moment().endOf("day")],
        },
        {
          label: "Last Week",
          range: [moment().subtract(13, "day").startOf("day"), moment().subtract(7, "day").endOf("day")],
        },
        {
          label: "This Month",
          range: [moment().startOf("month").startOf("day"), moment().endOf("month")],
        },
        {
          label: "Last Month",
          range: [moment().subtract(2, "month").startOf("day"), moment().subtract(1, "month").endOf("day")],
        },
      ],
    timer: true,
    loader: null,
    loading5: false,
    loading: true,
    board:[],
    voltage: [],
    volt1: [],
    volt2: [],
    volt3: [],
    total1: [],
    total2: [],
    total3: [],
    total4: [],
    totalAll: [],
    tab: null,
    boardName: [],
    boardItem: [],
    currentChart: {
        chart: {
          type: "line",
        animations: {
            enabled: false
        }
        },
        markers: {
          size: 0
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          type: "datetime",
          labels: {
            datetimeUTC: false,
          },
        },
        tooltip: {
          x: {
            format: "dd MMM yyyy hh:mm:ss tt",
          },
        },
        legend: {
          show: false,
          showForSingleSeries: true,
          position: "top",
        },
        title: {
            text: 'DB Current Consumption',
            align: 'center',
            floating: false,
            style: {
            fontSize:  '14px',
            fontWeight:  'bold',
          },
        },
        yaxis: {
      axisTicks: {
        show: true
      },
      labels: {
        formatter: (val) => { return val.toFixed(2) + 'A' },
      },
    },
    stroke: {
    show: true,
    curve: 'smooth',
    lineCap: 'butt',
    colors: undefined,
    width: 2,
    dashArray: 0,      
    },
  },
      currentSeries: [
        {
          data: [],
        },
      ],
  }),
  mounted() {
    this.loadsBoard();
    this.loadsBoardName();
    this.loadsVoltBoardName();
    this.loadsVoltage();
    this.intervalFetchData();
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  computed: {
     totalPower() {
      var name1 = this.boardItem;
      var amp = this.board.map((amp) => amp.fields.totalAll);
      var amp1 = amp[0];
      var v1 = this.voltage.map((v) => v.fields.v_phase1);
      var v1_1 = v1[0];
      var v2 = this.voltage.map((v) => v.fields.v_phase2);
      var v2_1 = v2[0];
      var v3 = this.voltage.map((v) => v.fields.v_phase3);
      var v3_1 = v3[0];
      switch(name1) {
      case 'DBGF':
      return (amp1 * v3_1 / 1000).toFixed(2); 
      case 'DB1F':
      return (amp1 * v1_1 / 1000).toFixed(2); 
      case 'DBPR':
      return (amp1 * v2_1 / 1000).toFixed(2); 
      default:
      return v1_1 + v2_1 + v3_1;
      }
    }
  },
  methods: {
    intervalFetchData: function () {
    setInterval(() => { 
    if(this.timer == true){     
      this.loadsBoard()}
       }, 60000); 
  },
    onResize() {
      this.isMobile = window.innerWidth < 700;
    },
  formatDate(value) {
      return moment(value).format("D MMM YYYY, h:mm:ss a")
  },
  loadsBoard: async function(){
  let apiURL = process.env.VUE_APP_API + "/api/ecms/" + this.boardItem + "/totalAmp/" + this.values1.toDate() + '/'+ this.values2.toDate();
  axios.get(apiURL).then(res => {
    this.board = res.data;
    this.totalAll = res.data.map((value) => value.fields.totalAll);

    let current = this.board.map((e) => {
            return {
              x: e.timestamp,
              y: e.fields.totalAll,
            };
          });

      this.currentSeries = [
            {
              name: "Current",
              data: current,
            },
          ];
  }).catch(error => {
    console.log(error)
  }).finally(() => this.loading = false);
},
loadsVoltage: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/cms/"+ this.voltBoardItem + "/volt/" + this.values1.toDate() + '/'+ this.values2.toDate();
    axios.get(apiURL).then(res => {
    this.voltage = res.data;
    this.volt1 = res.data.map((v) => v.fields.v_phase1);
    this.volt2 = res.data.map((v) => v.fields.v_phase2);
    this.volt3 = res.data.map((v) => v.fields.v_phase3);
    }).catch(error => {
    console.log(error)
    }).finally(() => this.loading = false);
  },
loadsBoardName: async function(){
      let apiURL = process.env.VUE_APP_API + "/api/board";
      axios.get(apiURL).then(res => {
      this.boardName = res.data;
      this.boardItem = this.boardName[0].boardName1A;
      this.loadsBoard();
      }).catch(error => {
      console.log(error)
      });
},
 loadsVoltBoardName: async function(){
      let apiURL = process.env.VUE_APP_API + "/api/single-phase";
      axios.get(apiURL).then(res => {
      this.voltBoard = res.data;
      this.voltBoardItem = this.voltBoard[0].boardName;
      this.loadsVoltage();
      }).catch(error => {
      console.log(error)
      });
  },
updateData(values){
      this.values1 = values[0];
      this.values2 = values[1];
      this.loadsBoard();
      this.loadsVoltage();
      this.loading = true;
    },

updateBoard(){
      this.loadsBoard();
      this.loadsVoltage();
      this.loading = true;
    },

  },
beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },
  watch: {
      loader () {
        const l = this.loader
        this[l] = !this[l]

        setTimeout(() => (this[l] = false), 500)

        this.loader = null
      },
    },
}
</script>

<style scoped>
table, th, td {
  border: 2px groove;
}
th{
  background-color: rgb(35, 35, 35);
}
</style>